import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import FooterBottom from './FooterBottom';
import Newsletter from '../../Common/Newsletter';
import axios from 'axios';

const Footer = (props) => {
    const [footerData, setFooterData] = useState(null);

    useEffect(() => {
        // Fetch the footer data from the API
        axios.get('https://yautiktechnology.com/api/footer')
            .then(response => {
                setFooterData(response.data[0]); // Assuming the API returns an array
            })
            .catch(error => {
                console.error('Error fetching footer data:', error);
            });
    }, []);

    if (!footerData) {
        return null; // Show nothing or a loader while the data is being fetched
    }

    const { footerLogo, footerClass } = props;
    const {
        imageUrl,
        description,
        servicesNameWithUrl,
        address,
        contactNumber,
        emailId,
        availability,
        linkedinUrl,
        upworkImg,
        upworkUrl,
        copyright,
        menuNameWithUrl
    } = footerData;

    return (
        <footer className={footerClass ? footerClass : 'rs-footer'}>
            <div className="footer-top">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="footer-logo">
                                <Link to="/">
                                    <img src={footerLogo || imageUrl} alt="Logo" />
                                </Link>
                            </div>
                            <div className="textwidget pb-30">
                                <p>{description}</p>
                            </div>
                            <ul className="footer-social md-mb-30">
                                <li>
                                    <a href={linkedinUrl}><i className="fa fa-linkedin"></i></a>
                                </li>
                                <li>
                                    <a href={upworkUrl} target="_blank" rel="noopener noreferrer">
                                        <img className="upwork-g" src={upworkImg} alt="Upwork" />
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-3 col-md-12 col-sm-12 pl-44 md-pl-14 md-mb-30">
                            <h3 className="widget-title">{footerData.serviceHeading}</h3>
                            <ul className="site-map">
                                {Object.entries(servicesNameWithUrl).map(([service, url]) => (
                                    <li key={service}><Link to={url}>{service}</Link></li>
                                ))}
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12 md-mb-30">
                            <h3 className="widget-title">Contact Info</h3>
                            <ul className="address-widget">
                                <li>
                                    <i className="flaticon-location"></i>
                                    <div className="desc">{address}</div>
                                </li>
                                <li>
                                    <i className="flaticon-call"></i>
                                    <div className="desc">
                                        <Link to={`tel:${contactNumber}`}>{contactNumber}</Link>
                                    </div>
                                </li>
                                <li>
                                    <i className="flaticon-email"></i>
                                    <div className="desc">
                                        <Link to={`mailto:${emailId}`}>{emailId}</Link>
                                    </div>
                                </li>
                                <li>
                                    <i className="flaticon-clock"></i>
                                    <div className="desc">{availability}</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <FooterBottom>
                
            </FooterBottom>
        </footer>
    );
};

export default Footer;
